import { Outlet, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { WELLMAKERS, ENVIRONMENT } from "@constants";
import CopyRight from "./components/CopyRight";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";

const Layout = () => {
  const location = useLocation();
  const isWellmakersHomePage = location.pathname.includes(WELLMAKERS);

  return (
    <div id="enerinvest-root" data-testid="enerinvest-layout-root" data-environment={ENVIRONMENT}>
      {!isWellmakersHomePage ? <Navbar /> : null}
      <Outlet />
      {!isWellmakersHomePage ? (
        <>
          <Footer />
          <CopyRight />
        </>
      ) : null}
      <ToastContainer stacked className="top-24" />
    </div>
  );
};

export default Layout;
